import { Input, type InputProps } from "@/components/base/input/input";
import { useFieldContext } from "..";
import { FieldErrors } from "./FieldErrors";

interface InputFieldProps
	extends Omit<InputProps, "value" | "onChange" | "onBlur" | "name"> {
	label?: string;
	field?: any; // Simplified for now - will be properly typed later
}

const InputField = (props: InputFieldProps) => {
	// Support both patterns:
	// 1. form.Field with explicit field prop
	// 2. form.AppField with useFieldContext
	const contextField = useFieldContext<string>();
	const field = props.field || contextField;
	return (
		<div className="">
			<Input
				{...props}
				id={field.name}
				name={field.name}
				value={field.state.value}
				onChange={(e) => field.handleChange((e as any).target?.value || e)}
				onBlur={field.handleBlur}
				label={props.label}
				isInvalid={
					(field.state.meta.isTouched || field.state.meta.isDirty) &&
					!field.state.meta.isValid
				}
				isDisabled={props.isDisabled}
			/>
			<FieldErrors meta={field.state.meta} />
		</div>
	);
};

export default InputField;
